import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { CusatFilters } from '../interfaces';

export const changeFilter = createAction<{
  key: keyof CusatFilters;
  value: CusatFilters[keyof CusatFilters];
}>(`${storeName}/changeFilter`);
